import authApi from 'api/authApi';
import feApi from 'api/feApi';
import { FastField, Formik } from 'formik';
import { motion } from 'framer-motion';
import KTFormGroup from 'general/components/OtherKeenComponents/Forms/KTFormGroup';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import AppColors from 'general/constants/AppColors';
import AppRoute from 'general/constants/AppRoute';
import ToastHelper from 'general/helpers/ToastHelper';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import * as Yup from 'yup';

ResetPasswordForm.propTypes = {};

function ResetPasswordForm(props) {
  // MARK: ---- params ----
  const router = useRouter();
  const query = router?.query;
  const prefillEmail = query.email;
  const prefillToken = query.token;

  // MARK: ---- methods ----

  const handleChangePassword = async (email, token, newPassword) => {
    try {
      const res = await authApi.resetPasswordUser(email, token, newPassword);
      const { result } = res;
      if (result === 'success') {
        ToastHelper.showSuccess('Đổi mật khẩu thành công');
        // chuyen sang man dang nhap
        router.navigate(`${AppRoute.auth}/sign-in`);
      }
    } catch (error) {
      const msg = error?.response?.data?.reason ?? '';
      ToastHelper.showError(msg);
    }
  };

  return (
    <motion.div
      className="login-form"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.1 }}
    >
      {/* form */}
      <Formik
        initialValues={{
          token: prefillToken,
          newPassword: '',
          retypeNewPassword: '',
        }}
        enableReinitialize
        validationSchema={Yup.object({
          token: Yup.string().required('Bạn chưa nhập mã xác thực'),
          newPassword: Yup.string().required('Bạn chưa nhập mật khẩu'),
          retypeNewPassword: Yup.string()
            .required('Bạn chưa nhập mật khẩu')
            .oneOf([Yup.ref('newPassword')], 'Mật khẩu không khớp'),
        })}
        onSubmit={(values) => {
          handleChangePassword(prefillEmail, values.token, values.newPassword);
        }}
      >
        {(formikProps) => (
          <div className="form fv-plugins-bootstrap fv-plugins-framework">
            {/* title */}
            <div className="pt-lg-0 pt-5 text-center">
              <h3
                className="font-weight-boldest"
                style={{ fontSize: Utils.returnFontSize(30), color: AppColors.gray[900] }}
              >
                Đặt lại mật khẩu
              </h3>
              <p
                className="font-weight-bolder mb-2"
                style={{ fontSize: Utils.returnFontSize(16), color: AppColors.gray[500] }}
              >
                Nhập thông tin để tiến hành đặt lại mật khẩu
              </p>
            </div>

            {/* token */}
            <KTFormGroup
              isRequired={true}
              label={'Mã đổi mật khẩu'}
              inputName="token"
              additionalClassName="fv-plugins-icon-container mb-4 pt-8"
              additionalLabelClassName="mb-0 font-size-h6 font-weight-bolder text-gray-700"
              inputElement={
                <FastField name="token">
                  {({ field, form, meta }) => (
                    <KTFormInput
                      name={field.name}
                      value={field.value}
                      onChange={(value) => {
                        form.setFieldValue(field.name, value);
                      }}
                      onBlur={() => {
                        form.setFieldTouched(field.name, true);
                      }}
                      enableCheckValid
                      isValid={_.isEmpty(meta.error)}
                      isTouched={meta.touched}
                      feedbackText={meta.error}
                      type={KTFormInputType.text}
                      placeholder="Nhập mã đối mật khẩu"
                      solidBackground
                      additionalInputClassName="h-55px"
                    />
                  )}
                </FastField>
              }
            />

            {/* new password */}
            <KTFormGroup
              isRequired={true}
              label={'Mật khẩu mới'}
              inputName="newPassword"
              additionalClassName="fv-plugins-icon-container mb-4"
              additionalLabelClassName="mb-0 font-size-h6 font-weight-bolder text-gray-700"
              inputElement={
                <FastField name="newPassword">
                  {({ field, form, meta }) => (
                    <KTFormInput
                      name={field.name}
                      value={field.value}
                      onChange={(value) => {
                        form.setFieldValue(field.name, value);
                      }}
                      onBlur={() => {
                        form.setFieldTouched(field.name, true);
                      }}
                      enableCheckValid
                      isValid={_.isEmpty(meta.error)}
                      isTouched={meta.touched}
                      feedbackText={meta.error}
                      type={KTFormInputType.password}
                      placeholder="Nhập mật khẩu mới"
                      solidBackground
                      additionalInputClassName="h-55px"
                    />
                  )}
                </FastField>
              }
            />

            {/* nhap lai mat khau moi */}
            <KTFormGroup
              isRequired={true}
              label={'Nhập lại mật khẩu mới'}
              inputName="retypeNewPassword"
              additionalClassName="fv-plugins-icon-container mb-4"
              additionalLabelClassName="mb-0 font-size-h6 font-weight-bolder text-gray-700"
              inputElement={
                <FastField name="retypeNewPassword">
                  {({ field, form, meta }) => (
                    <KTFormInput
                      name={field.name}
                      value={field.value}
                      onChange={(value) => {
                        form.setFieldValue(field.name, value);
                      }}
                      onBlur={() => {
                        form.setFieldTouched(field.name, true);
                      }}
                      enableCheckValid
                      isValid={_.isEmpty(meta.error)}
                      isTouched={meta.touched}
                      feedbackText={meta.error}
                      type={KTFormInputType.password}
                      placeholder="Nhập lại mật khẩu mới"
                      solidBackground
                      additionalInputClassName="h-55px"
                    />
                  )}
                </FastField>
              }
            />

            {/* action */}
            <div className="form-group d-flex gap-3 flex-wrap pb-lg-0">
              <button
                type="button"
                className="btn btn-light font-weight-bolder font-size-h6 px-8 py-4 my-3 flex-grow-1 d-flex align-items-center justify-content-center"
                onClick={() => {
                  router.navigate(`${AppRoute.auth}/sign-in`);
                }}
              >
                Hủy bỏ
              </button>
              <button
                type="submit"
                className="btn btn-success font-weight-bolder font-size-h6 px-8 py-4 my-3 flex-grow-1 d-flex align-items-center justify-content-center"
                onClick={() => {
                  formikProps.handleSubmit();
                }}
              >
                Đặt lại mật khẩu
              </button>
            </div>
          </div>
        )}
      </Formik>
    </motion.div>
  );
}

export default ResetPasswordForm;
